import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_VEHICLE_VEHICLESTATUS_LIST, 
  TOAST, 
  FETCH_VEHICLE_VEHICLESTATUS_INIT,
  FETCH_VEHICLE_VEHICLESTATUS_DETAIL,
  EXPORT_VEHICLE_VEHICLESTATUS,
  CREATE_VEHICLE_VEHICLESTATUS,
  EDIT_VEHICLE_VEHICLESTATUS,
  INIT_CREATE_VEHICLE_VEHICLESTATUS_SCREEN,
  VEHICLE_STATUSDD,
  DELETE_VEHICLE_VEHICLESTATUS,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  VEHICLE_VEHICLESTATUS_SAVE_TABLE_STATE,
} from "../../../types/vehiclevehiclestatus.type";



  const formFieldValueMap = {
    id:null,
    description:"",
    modBy:"",
    modTime:"",
    status:1,
    title:"",
    userId:""
  };
  
  const INITIAL_STATE = {
    vehicleVehicleStatusListview: [],
    vehicleStatusDD:[],
    isVehicleStatusDDSuccess: false,
    isVehicleStatusDDError: false,
    isLoading: false,
    error: null,
    formFieldValueMap,
    isVehicleVehicleStatusCreateSuccess: false,
    isVehicleVehicleStatusCreateError: false,
    isVehicleVehicleStatusDetailSuccess: false,
    isVehicleVehicleStatusDetailError: false,
    isVehicleVehicleStatusEditSuccess: false,
    isVehicleVehicleStatusEditError: false,
    isVehicleVehicleStatusExportSuccess: false,
    isVehicleVehicleStatusExportError: false,
    isVehicleVehicleStatusDeleteSuccess: false,
    isVehicleVehicleStatusDeleteError: false,
    shouldOpenDeleteConfirmationPopup: false,
    savedTableState: null,
    isUploadImageSuccess: false,
    isUploadImageError: false,
    imageUploadResponse:null
  };
  
  const tranformToGridView = (data) => {
    const rows = data.map((item) => {
      const {
        crtBy,
crtTime,
description,
id,
modBy,
modTime,
status,
title
      } = item;
  
      const transformedValues = {
        crtBy,
crtTime,
description,
id,
modBy,
modTime,
status,
title
      };
      const decoratedValues = {};
      Object.keys(transformedValues).forEach((key) => {
        decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
      });
      return decoratedValues;
    });
  
    const columns = [
      {
        colLabel: "ID",
        dataKey: "id",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Vehicle Status",
        dataKey: "title",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Description",
        dataKey: "description",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      
     
      {
        colLabel: "Crt By",
        dataKey: "crtBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Crt Time",
        dataKey: "crtTime",
        extraProps: {
          isSortable: true,
          isDateField: true,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Mod By",
        dataKey: "modBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Edit Time",
        dataKey: "modTime",
        extraProps: {
          isSortable: true,
          isDateField: true,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Status",
        dataKey: "status",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      }
    ];
  
    return {
      datas: { columns, rows },
    };
  };

  export const vehicleVehicleStatusReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_VEHICLE_VEHICLESTATUS_INIT:
        return { ...INITIAL_STATE, savedTableState: state.savedTableState, isLoadingPage: true };
      case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
        return { ...state, shouldOpenDeleteConfirmationPopup: action.payload };
      case FETCH_VEHICLE_VEHICLESTATUS_DETAIL.START:
        return { ...state, isLoading: true, isVehicleVehicleStatusDetailSuccess: false };
      case EXPORT_VEHICLE_VEHICLESTATUS.START:
        case UPLOAD_IMAGE.START:
      case FETCH_VEHICLE_VEHICLESTATUS_LIST.START:
      case CREATE_VEHICLE_VEHICLESTATUS.START:
      case DELETE_VEHICLE_VEHICLESTATUS.START:
        case EDIT_VEHICLE_VEHICLESTATUS.START:
          case VEHICLE_STATUSDD.START:
        return { ...state, isLoading: true };
  
      case FETCH_VEHICLE_VEHICLESTATUS_LIST.SUCCESS: {
        const { page, data } = action.payload;
       
        let resetState = {
          vehicleVehicleStatusListview: [],
          paginationInfo:null,
          error: null,
          isLoading: false,
          isLoadingPage: false,
          isPageLevelError: false,
          isVehicleVehicleStatusCreateSuccess: false,
          isVehicleVehicleStatusCreateError: false,
          savedTableState: state.savedTableState,
        };
        if (!data) {
          return resetState;
        }
        const { number, size, totalElements, totalPages } = page;
        const { datas } = tranformToGridView(data);
        return {
          ...resetState,
          vehicleVehicleStatusListview: datas,
          paginationInfo: {
            pageSize: size,
            totalRecords: totalElements,
            totalPages: totalPages,
            pageNumber: number,
          },
        };
      }
      case FETCH_VEHICLE_VEHICLESTATUS_LIST.ERROR: {
        const { error } = action.payload;
  
        return {
          ...state,
          vehicleVehicleStatusListview: [],
          isLoading: false,
          isLoadingPage: false,
          error,
          isPageLevelError: true,
          isvehicleVehicleStatusDeletionSuccess: false,
          isvehicleVehicleStatusDeletionError: false,
          shouldOpenDeleteConfirmationPopup: false,
        };
      }

    case FETCH_VEHICLE_VEHICLESTATUS_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
              temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isVehicleVehicleStatusDetailSuccess: true,
      };
    }
    case FETCH_VEHICLE_VEHICLESTATUS_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleVehicleStatusDetailSuccess: false,
        isVehicleVehicleStatusDetailError: true,
      };
    }

    //DD
    case VEHICLE_STATUSDD.SUCCESS: {
      const temp = action.payload;
 
      return {
        ...state,
        isLoading: false,
        vehicleStatusDD:temp,
        isVehicleStatusDDSuccess: true,
        isVehicleStatusDDError: false,
      };
    }
    case VEHICLE_STATUSDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleStatusDDSuccess: false,
    isVehicleStatusDDError: true,
      };
    }
    //END DD
    
    
// UPLOAD_IMAGE Start
case UPLOAD_IMAGE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isUploadImageSuccess: false,
    isUploadImageError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case UPLOAD_IMAGE.SUCCESS: {
  const  {data}  = action.payload;
   return {
    ...state,
    imageUploadResponse:data,
    isUploadImageSuccess: true,
    isUploadImageError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// UPLOAD_IMAGE End

// Export Start
case EXPORT_VEHICLE_VEHICLESTATUS.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isVehicleVehicleStatusExportSuccess: false,
    isVehicleVehicleStatusExportError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case EXPORT_VEHICLE_VEHICLESTATUS.SUCCESS: {
  const  data  = action.payload;
  arrayBufferDownloadExcel(data,"vehicle-status.xls");
   return {
    ...state,
    isVehicleVehicleStatusExportSuccess: true,
    isVehicleVehicleStatusExportError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// Export End

// EDIT
case EDIT_VEHICLE_VEHICLESTATUS.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isVehicleVehicleStatusEditSuccess: false,
    isVehicleVehicleStatusEditError: true,
  };
}

case EDIT_VEHICLE_VEHICLESTATUS.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isVehicleVehicleStatusEditSuccess: true,
    isVehicleVehicleStatusEditError: false,
  };
}

// EDIT END

// Create
case INIT_CREATE_VEHICLE_VEHICLESTATUS_SCREEN: {
  return { ...INITIAL_STATE, savedTableState: state.savedTableState };
}

case CREATE_VEHICLE_VEHICLESTATUS.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isVehicleVehicleStatusCreateSuccess: false,
    isVehicleVehicleStatusCreateError: true,
  };
}
case CREATE_VEHICLE_VEHICLESTATUS.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isVehicleVehicleStatusCreateSuccess: true,
    isVehicleVehicleStatusCreateError: false,
  };
}

//End

      case DELETE_VEHICLE_VEHICLESTATUS.SUCCESS: {
        return {
          ...state,
          isLoading: false,
          isVehicleVehicleStatusDeleteSuccess: true,
          isVehicleVehicleStatusDeleteError: false,
          shouldOpenDeleteConfirmationPopup: false,
        };
      }
      case DELETE_VEHICLE_VEHICLESTATUS.ERROR: {
        const { error } = action.payload;
        return {
          ...state,
          error,
          isLoading: false,
          isVehicleVehicleStatusDeleteSuccess: false,
          isVehicleVehicleStatusDeleteError: true,
        };
      }

      case VEHICLE_VEHICLESTATUS_SAVE_TABLE_STATE: {
        return { ...state, savedTableState: action.payload };
      }
      case TOAST.RESET: {
        return {
          ...state,
          isVehicleVehicleStatusCreateSuccess: false,
          isVehicleVehicleStatusCreateError: false,
          isVehicleVehicleStatusEditError: false,
          isVehicleVehicleStatusEditSuccess: false,
          isVehicleVehicleStatusDetailError: false,
          isVehicleVehicleStatusDeleteSuccess: false,
          isVehicleVehicleStatusDeleteError: false,
        };
      }
      default:
        return state;
    }
  };
  